import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AdminAppBody from '../../../../components/admin/AdminAppBody';
import PageHeading from '../../../../components/admin/common/PageHeading';
import { FaSave } from 'react-icons/fa';
import { toast } from 'react-toastify';
import useApiCallHooks from '../../../../hooks/useApiCallHooks';
import { apiRoutes } from '../../../../routes/api/apiRoutes';
import { uiRoutes } from '../../../../routes/ui/uiRoutes';

const AddService = () => {
  const navigate = useNavigate();
  const [responce, loading, error, callAPI, statusCode] = useApiCallHooks();
    const [isShow, setShow] = useState();

  const [data, setData] = useState({
    title: '',
    description: '',
    icon: null,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setData((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setData((prev) => ({ ...prev, icon: file }));
  };

  const onSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData();
    Object.entries(data).forEach(([key, val]) => formData.append(key, val));
    callAPI('post', apiRoutes.admin.services, formData);
  };

  useEffect(() => {
  if (statusCode === 201) {
    toast.success("Service added successfully!");
        setShow(true);
    const timer = setTimeout(() => {
      navigate(uiRoutes.admin.services.list);
    }, 1000);

    return () => clearTimeout(timer); // Cleanup on unmount/re-render
  }
}, [statusCode, navigate]);

  return (
    <AdminAppBody
      loading={loading}
      content={
        <div className="container">
          <PageHeading title="Add Service" subTitle="Create a new IT service" />
          <div className="card p-4 shadow-sm mt-4">
            <form onSubmit={onSubmit}>
              {/* Title */}
              <div className="mb-3">
                <label className="form-label fw-bold">Service Title</label>
                <input
                  type="text"
                  name="title"
                  className="form-control"
                  value={data.title}
                  onChange={handleChange}
                />
                <span className="text-danger">
                  {error?.message === 'ValidationError' && error?.data?.title}
                </span>
              </div>

              {/* Description */}
              <div className="mb-3">
                <label className="form-label fw-bold">Description</label>
                <textarea
                  name="description"
                  className="form-control"
                  value={data.description}
                  onChange={handleChange}
                  rows="4"
                ></textarea>
                <span className="text-danger">
                  {error?.message === 'ValidationError' && error?.data?.description}
                </span>
              </div>

              {/* Icon Upload */}
              <div className="mb-3">
                <label className="form-label fw-bold">Icon Image</label>
                <input
                  type="file"
                  name="icon"
                  className="form-control"
                  onChange={handleFileChange}
                />
                <span className="text-danger">
                  {error?.message === 'ValidationError' && error?.data?.icon}
                </span>
              </div>

              <button type="submit" className="btn btn-success">
                <FaSave className="me-2" /> Save Service
              </button>
            </form>
          </div>
        </div>
      }
    />
  );
};

export default AddService;
